/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/segment_cohort_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../../../../common";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/segment_cohort_remote_lookup_provider.rb) */
export const itemTypeSchema = z.strictObject({
  id: common.objectId,
  name: z.string().nullable().optional(),
  is_draft: z.boolean().nullable().optional(),
  is_archived: z.boolean().nullable().optional(),
  is_processed: z.boolean().nullable().optional(),
  is_auto_disabled: z.boolean().nullable().optional(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/segment_cohort_remote_lookup_provider.rb) */
export const itemTypeOutputSchema = z.object({
  id: common.objectId,
  name: z.string(),
  is_draft: z.boolean(),
  is_archived: z.boolean(),
  is_processed: z.boolean(),
  is_auto_disabled: z.boolean(),
});
